// @flow
import styled from '@emotion/styled';
import { css } from '@emotion/core';
import {
  typography,
  color,
  SPACING,
  FONT_WEIGHTS,
  CLASSIC_COLORS
} from '@tablekit/theme';
import { MAX_WIDTH } from 'utils/theme';
import columnWidth from 'utils/columnWidth';
import RichText from 'components/RichText';

export const GUTTER = parseInt(SPACING.L5, 10) / 2;

export const ShopListGrid = styled.div`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  margin: 0 -${GUTTER}px;
  width: calc(100% + ${GUTTER * 2}px);
  max-width: ${MAX_WIDTH};

  @media (min-width: 768px) {
    align-items: flex-start;
    flex-wrap: wrap;
    flex-direction: row;
    width: ${columnWidth(10)}%;
    margin: 0 auto;
  }
`;

export const gridElementStyles = css`
  margin: 0 ${GUTTER}px ${SPACING.L5};
  align-self: stretch;

  width: calc(100% - ${GUTTER * 2}px);

  @media (min-width: 768px) {
    width: calc(50% - ${GUTTER * 2}px);
  }

  @media (min-width: 1280px) {
    width: calc(33% - ${GUTTER * 2}px);
  }
`;

export const CardSeparator = styled.div`
  border-top: 1px solid ${color('surfaceLow')};
  transition: transform 0.2s ease-in-out;
`;

export const ShopListHeading = styled(RichText)`
  margin: ${GUTTER}px 0;
  width: 100%;
  max-width: ${MAX_WIDTH};
  font-weight: ${FONT_WEIGHTS.BOLD}};
  color: ${CLASSIC_COLORS.text};
  ${(props) => typography('L4')(props)};

  @media (min-width: 768px) {
    width: calc(${columnWidth(10)}% - ${GUTTER * 2}px);
    margin: 0 auto ${SPACING.L6} auto;
    ${(props) => typography('L7')(props)};
  }
`;
